<template>
  <div class="loading-wrap">
    <div ref="Loading" class="loading-icon icon"></div>
    <p v-if="loadTips" :class="{ 'is-white': white }">{{ $t('base_loading') }}</p>
  </div>
</template>
<script lang="ts" setup>
import lottie from 'lottie-web'
import blackLoading from '~~/assets/json/black_loading.json'
import whiteLoading from '~~/assets/json/white_loading.json'

const props = defineProps({
  white: {
    type: Boolean,
    default: false,
  },
  loadTips: {
    type: Boolean,
    default: false,
  },
})

const instance = ref()
const Loading = ref()

onMounted(() => {
  instance.value = lottie.loadAnimation({
    container: Loading.value,
    renderer: 'svg',
    loop: true,
    autoplay: true,
    animationData: props.white ? whiteLoading : blackLoading,
  })
})
onUnmounted(() => instance.value.destroy())
</script>
<style lang="less" scoped>
.loading-wrap {
  display: flex;
  justify-content: center;
  align-items: center;
  p {
    margin-left: 8px;
    font-size: 14px;
    color: @Text50;
  }
  .is-white {
    color: @Text20;
  }
}
.loading-icon {
  display: flex;
  width: 20px;
  height: 20px;
}
</style>
